import { FC, ReactNode } from "react";

interface FormPageProps {
  children: ReactNode;
}

const FormPage: FC<FormPageProps> = ({ children }) => {
  return <div className="form-page overflow-x-hidden pb-10">{children}</div>;
};

export default FormPage;
